import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { SubmitButton } from 'framework/ui/ui-builder';
import React from 'react';
import { useFormContext } from 'framework/form';

const UpdateStaffingAssignmentModalActions = ({
  closeModal,
  onDeleteAction,
}: {
  closeModal: () => void;
  onDeleteAction: () => void;
}) => {
  const { submitForm, isSubmitEnabled = true, isLoadingArtifact } = useFormContext();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, pt: 1 }}>
      <Box>
        <Button
          variant="contained"
          color="error"
          onClick={onDeleteAction}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Delete
        </Button>
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="outlined" onClick={closeModal} disabled={!isSubmitEnabled || isLoadingArtifact}>
          Cancel
        </Button>
        <SubmitButton onClick={submitForm} isLoading={!isSubmitEnabled} disabled={isLoadingArtifact} />
      </Box>
    </Box>
  );
};

export default UpdateStaffingAssignmentModalActions;
